// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 513) return "static/css/513.3c88737cb.chunk.css";
	// return url for filenames based on template
	return undefined;
};